var map = {
	"./en/buttons.json": 11004,
	"./en/dialogs.json": 67367,
	"./en/elements.json": 31558,
	"./en/music.json": 56361,
	"./en/shortcuts.json": 74638,
	"./fr/buttons.json": 20252,
	"./fr/dialogs.json": 51364,
	"./fr/elements.json": 59336,
	"./fr/music.json": 99910,
	"./fr/shortcuts.json": 2526,
	"./sl/buttons.json": 87255,
	"./sl/dialogs.json": 60529,
	"./sl/elements.json": 66708,
	"./sl/music.json": 14177,
	"./sl/shortcuts.json": 36294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;